import { createElement } from "react";
import React from "react";
import * as react from "react";
import { int32ToString, defaultOf, uncurry2, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Link, Divider, TextField, Typography } from "@mui/material";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { ctx as ctx_1 } from "../Context.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { loadingIndicatorSmall, SnackError } from "../ViewHelpers.js";
import { value as value_196, some, map, defaultArg, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { History } from "./MachineNotesHistory.js";
import { now, compare, parse } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { toDateStr, toDateOnlyStr, toDateAndTimeStr } from "../Locale.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import Edit from "@mui/icons-material/Edit";
import Receipt from "@mui/icons-material/Receipt";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { obj_type, anonRecord_type, string_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { MachineNote_$reflection } from "../Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { parseDateIso, Links_MachinePath } from "../Utils.js";
import { Components_Shortcut_Z74A6BA73 } from "../Components/Shortcut.js";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import Build from "@mui/icons-material/Build";
import People from "@mui/icons-material/People";
import { interpolate, toText, isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { fromDateTime, parse as parse_1 } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { ComponentsModule_Chip_Level, Components_Chip_51BC9844 } from "../Components/Chip.js";
import Warning from "@mui/icons-material/Warning";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { MuiXHelpers_createElement } from "../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Components_ActivityCalendar_Z2E686B84 } from "../Components/Activities/ActivityCalendar.js";
import { Tickets_StatusCard_Z2E686B84 } from "../Components/Tickets/StatusCard.js";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Components_OrderStatusCard_Z2E686B84 } from "../Components/OrderStatusCard.js";
import { Tickets_WarrantyStatusCard_Z2E686B84 } from "../Components/Tickets/WarantyStatusCard.js";

function Machine_row_6162D7CC(header, value) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px",
        padding: 10 + "px",
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["sx", {
        flexShrink: 0,
        flexBasis: 40 + "%",
    }], ["noWrap", true], ["children", header]]), createElement("div", {
        style: {
            minWidth: 0 + "px",
        },
        children: value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Machine_Notes_619E2B23(machineInfo) {
    let elems_4;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setHasEdited = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setEditForm = patternInput_1[1];
    const editForm = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setProcessing = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const viewHistory = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setErrMsg = patternInput_4[1];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 15 + "px",
    }], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(singleton_1((elems = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("MachineView.MachineNotes")]]), MuiHelpers_createElement(Typography, [["sx", {
            color: "var(--grey-blue)",
        }], ["variant", "body2"], ["children", ctx.Locale.t("MachineView.NotesDescription")]])], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => append(singleton(createElement(SnackError, {
            errMsg: unwrap(patternInput_4[0]),
            dismiss: () => {
                setErrMsg(undefined);
            },
        })), delay(() => {
            let matchValue_1;
            return append(viewHistory ? singleton(createElement(History, {
                machineId: machineInfo.Id,
            })) : append((matchValue_1 = editForm, (matchValue_1 != null) ? singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["autoFocus", true], ["multiline", true], ["minRows", 5], ["value", matchValue_1], ["onChange", (e) => {
                setEditForm(e.target.value);
                setHasEdited(true);
            }]])) : singleton(MuiHelpers_createElement(TextField, [["disabled", true], ["autoFocus", false], ["multiline", true], ["minRows", 5], ["value", defaultArg(map((_arg_4) => _arg_4.Note, machineInfo.LatestNote), "")]]))), delay(() => {
                let elems_2, elems_1;
                const matchValue_2 = machineInfo.LatestNote;
                if (matchValue_2 != null) {
                    const ln = matchValue_2;
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        width: 100 + "%",
                        padding: 10,
                        border: (((1 + "px ") + "solid") + " ") + "var(--grey)",
                        borderRadius: 5,
                    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                    }], (elems_1 = toList(delay(() => {
                        const noteCreated = parse(ln.Updated);
                        return append(singleton(MuiHelpers_createElement(Typography, [["style", {
                            fontSize: 0.8 + "rem",
                            color: "#7a7a7a",
                            flexGrow: 1,
                        }], ["children", `${toDateAndTimeStr(ctx.DateFnsLocale, noteCreated)} - ${ln.UpdatedBy.Email}`]])), delay(() => singleton(createElement(Components_Button_Z1043B8E, {
                            text: ctx.Locale.t("Edit"),
                            onClick: (_arg_5) => {
                                setEditForm(ln.Note);
                            },
                            startIcon: (props_6) => {
                                const props_8 = createObj(props_6);
                                return react.createElement(Edit, props_8);
                            },
                        }))));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }
                else {
                    return empty();
                }
            })), delay(() => {
                let elems_3;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignSelf: "flex-end",
                    gap: 10 + "px",
                }], (elems_3 = toList(delay(() => {
                    if (editForm == null) {
                        return append(singleton(createElement(Components_Button_Z1043B8E, {
                            text: ctx.Locale.t("Pages.History"),
                            onClick: (_arg_8) => {
                                console.debug("Toggle history");
                                patternInput_3[1](!viewHistory);
                            },
                            startIcon: (props_11) => {
                                const props_13 = createObj(props_11);
                                return react.createElement(Receipt, props_13);
                            },
                        })), delay(() => singleton(createElement(Components_Button_Z1043B8E, {
                            text: ctx.Locale.t("CustomerSite.Overview.NewNote"),
                            onClick: (_arg_9) => {
                                setEditForm("");
                            },
                            startIcon: (props_14) => {
                                const props_16 = createObj(props_14);
                                return react.createElement(Edit, props_16);
                            },
                        }))));
                    }
                    else {
                        const form = editForm;
                        return patternInput_2[0] ? singleton(loadingIndicatorSmall()) : append(singleton(createElement(Components_Button_Z1043B8E, {
                            text: ctx.Locale.t("Cancel"),
                            onClick: (_arg_6) => {
                                setEditForm(undefined);
                                setHasEdited(false);
                            },
                        })), delay(() => singleton(createElement(Components_Button_Z1043B8E, {
                            text: ctx.Locale.t("Update"),
                            onClick: (_arg_7) => {
                                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                    let item, body, decoder, data_1, caseStrategy_3, extra_3;
                                    setProcessing(true);
                                    return ((item = {
                                        MachineId: machineInfo.Id,
                                        Notes: form,
                                    }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["MachineId", int32_type], ["Notes", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(MachineNote_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                                        let properties_2;
                                        try {
                                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/machine/notes", properties_3).then((_arg) => {
                                                let response_1, decoder_1_1;
                                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(MachineNote_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                                    let matchValue;
                                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                                            }))));
                                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                                        }
                                        catch (exn) {
                                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                                        }
                                    })()))))))).then((_arg_2) => {
                                        const res = _arg_2;
                                        if (res.tag === 1) {
                                            const err = res.fields[0];
                                            setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("MachineView.UpdateNotesUnauthorized") : (((err.fields[0].status) === 404) ? ctx.Locale.t("MachineView.UpdateNotesMachineNotFound") : ctx.Locale.t("MachineView.UpdatedNotesFailed"))) : ctx.Locale.t("MachineView.UpdatedNotesFailed"));
                                            setProcessing(false);
                                            return Promise.resolve();
                                        }
                                        else {
                                            setHasEdited(false);
                                            setEditForm(undefined);
                                            setProcessing(false);
                                            setErrMsg(undefined);
                                            return Promise.resolve();
                                        }
                                    });
                                }));
                                pr_1.then();
                            },
                            disabled: !patternInput[0],
                        }))));
                    }
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function Machine_Overview_Z259FB9E(machine_Overview_Z259FB9EInputProps) {
    let elems_1, elems, elems_7, elems_3, elems_2, elems_6, elems_17, elems_10, elems_9, value_119, elems_8, elems_16, elems_15;
    const customerId = machine_Overview_Z259FB9EInputProps.customerId;
    const groupId = machine_Overview_Z259FB9EInputProps.groupId;
    const info = machine_Overview_Z259FB9EInputProps.info;
    const ctx = reactApi.useContext(ctx_1);
    const machine = info.Machine;
    const machinePageUrl = (arg) => RouterModule_encodeParts(ofArray(Links_MachinePath(groupId, customerId, machine.Id, arg)), 1);
    const patternInput = defaultArg(map((sess) => [sess.IsSuperAdmin ? true : sess.IsAdmin, sess.IsPtg, sess.TicketAccess], ctx.Session), [false, false, false]);
    const isAdmin = patternInput[0];
    const hasTicketAccess = patternInput[2];
    const isCustomer = !isAdmin && !patternInput[1];
    const orderServiceHref = machinePageUrl(isCustomer ? "tickets" : "activity-plan");
    const textCell = (text) => MuiHelpers_createElement(Typography, [["variant", "body1"], ["noWrap", true], ["children", text]]);
    const xs_20 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.WhatDoYouWantToDo")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 30 + "px",
    }], (elems = toList(delay(() => append(singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.MyFGas"),
        lower: ctx.Locale.t("CustomerSite.Overview.Accounting"),
        href: machinePageUrl("gasreport"),
        icon: (props_2) => {
            const props_4 = createObj(props_2);
            return react.createElement(Receipt, props_4);
        },
    })), delay(() => append(singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.SeeMy"),
        lower: ctx.Locale.t("CustomerSite.Overview.Invoice"),
        href: machinePageUrl("economy"),
        icon: (props_5) => {
            const props_7 = createObj(props_5);
            return react.createElement(ReceiptLong, props_7);
        },
    })), delay(() => append((info.Customer.EnableServices && (!isCustomer ? true : hasTicketAccess)) ? singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("Order"),
        lower: ctx.Locale.t("CustomerSite.Overview.service"),
        href: orderServiceHref,
        icon: (props_8) => {
            const props_10 = createObj(props_8);
            return react.createElement(Build, props_10);
        },
    })) : empty(), delay(() => singleton(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.Help"),
        lower: ctx.Locale.t("CustomerSite.Overview.Kundeweb"),
        href: RouterModule_encodeParts(singleton_1("helpdesk"), 1),
        icon: (props_11) => {
            const props_13 = createObj(props_11);
            return react.createElement(People, props_13);
        },
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 40 + "px",
    }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 300 + "px",
        maxWidth: 600 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("MachineView.MachineInfo")]]), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px",
    }], (elems_2 = toList(delay(() => append(singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.MachineNumber"), textCell(`#${machine.Number}`))), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => {
        let matchValue, we, dateStr;
        return append(singleton(Machine_row_6162D7CC(ctx.Locale.t("Economy.Warranty"), createElement("div", {
            style: {
                display: "flex",
            },
            children: (matchValue = machine.WarrantyExpiry, (matchValue != null) ? ((we = parse_1(matchValue), (dateStr = toDateOnlyStr(ctx.DateFnsLocale, we), (compare(we, fromDateTime(now())) <= 0) ? createElement(Components_Chip_51BC9844, {
                key: "machine-waranty-chip",
                $key: "machine-waranty-chip",
                primary: ctx.Locale.t("MachineView.Expired", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["dateStr", dateStr])),
                enabled: true,
                startIcon: (props_21) => {
                    const props_23 = createObj(props_21);
                    return react.createElement(Warning, props_23);
                },
                colorLevel: new ComponentsModule_Chip_Level(3, []),
            }) : createElement(Components_Chip_51BC9844, {
                key: "machine-waranty-chip",
                $key: "machine-waranty-chip",
                primary: ctx.Locale.t("MachineView.ActiveUtil", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["dateStr", dateStr])),
                enabled: true,
                startIcon: (props_24) => {
                    const props_26 = createObj(props_24);
                    return react.createElement(CheckCircle, props_26);
                },
                colorLevel: new ComponentsModule_Chip_Level(1, []),
            })))) : createElement(Components_Chip_51BC9844, {
                key: "machine-waranty-chip",
                $key: "machine-waranty-chip",
                primary: ctx.Locale.t("MachineView.Inactive"),
                enabled: true,
                startIcon: (props_18) => {
                    const props_20 = createObj(props_18);
                    return react.createElement(Warning, props_20);
                },
            })),
        }))), delay(() => append(!isNullOrWhiteSpace(machine.Compressor) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Compressor"), textCell(machine.Compressor))))) : empty(), delay(() => append(!isNullOrWhiteSpace(machine.SerialNumber) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Snr"), textCell(machine.SerialNumber))))) : empty(), delay(() => append((machine.Type != null) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Type"), textCell(value_196(machine.Type).Name))))) : empty(), delay(() => append(!isNullOrWhiteSpace(machine.Oil) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Oil"), textCell(machine.Oil))))) : empty(), delay(() => append(!isNullOrWhiteSpace(machine.Oil) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Cooling"), textCell(machine.Gas))))) : empty(), delay(() => append(!isNullOrWhiteSpace(machine.Filter) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC("Filter", textCell(machine.Filter))))) : empty(), delay(() => append((machine.FillAmount !== 0) ? append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.FillAmount"), textCell(toText(interpolate("%0.2f%P()kg", [machine.FillAmount]))))))) : empty(), delay(() => {
            if (machine.HandoverDate != null) {
                const date = value_196(machine.HandoverDate);
                return append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => singleton(Machine_row_6162D7CC(ctx.Locale.t("MachineView.Handover"), textCell(toDateStr(ctx.DateFnsLocale, parseDateIso(date)))))));
            }
            else {
                return empty();
            }
        }))))))))))))))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 40 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 300 + "px",
        maxWidth: 600 + "px",
    }], (elems_6 = toList(delay(() => {
        let matchValue_1, account, elems_5, elems_4;
        return append((matchValue_1 = info.Customer.Responsible, (matchValue_1 != null) ? ((account = matchValue_1, singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 15 + "px",
        }], (elems_5 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.MyPointOfContact")]]), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
            display: "flex",
            flexDirection: "column",
            gap: 10 + "px",
        }], (elems_4 = [Machine_row_6162D7CC("Navn", textCell(`${account.FirstName} ${account.LastName}`)), MuiHelpers_createElement(Divider, []), Machine_row_6162D7CC("Telefonnummer", MuiHelpers_createElement(Link, [["href", `tel:+${account.PhoneCC}${account.Phone}`], ["children", `+${account.PhoneCC} ${account.Phone}`]])), MuiHelpers_createElement(Divider, []), Machine_row_6162D7CC("Epost", MuiHelpers_createElement(Link, [["href", `mailto:${account.Email}`], ["children", account.Email]]))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))))) : (empty())), delay(() => (isAdmin ? singleton(createElement(Machine_Notes_619E2B23, machine)) : empty())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 40 + "px",
    }], (elems_17 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_10 = [MuiHelpers_createElement(Typography, [["sx", {
        maxWidth: 320 + "px",
    }], ["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.UpcomingEvents")]]), createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {}], (elems_9 = [MuiXHelpers_createElement(LocalizationProvider, [(value_119 = AdapterDateFns, ["dateAdapter", value_119]), (elems_8 = [createElement(Components_ActivityCalendar_Z2E686B84, {
        groupId: groupId,
        customerId: customerId,
        machineId: machine.Id,
    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 200 + "px",
        minWidth: 200 + "px",
        maxWidth: 800 + "px",
    }], (elems_16 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Ticket.Status.Status")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 15 + "px",
    }], (elems_15 = toList(delay(() => {
        let elems_11;
        return append(hasTicketAccess ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 15 + "px",
            minWidth: 185 + "px",
        }], (elems_11 = [createElement(Tickets_StatusCard_Z2E686B84, {
            groupId: groupId,
            customerId: customerId,
            machineId: machine.Id,
        }), createElement(Components_Button_Z1043B8E, {
            text: ctx.Locale.t("CustomerSite.Overview.TicketOverview"),
            onClick: (_arg) => {
                RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), "machine", int32ToString(machine.Id), "tickets"]), 1, 1);
            },
            startIcon: (props_52) => {
                const props_54 = createObj(props_52);
                return react.createElement(ArrowForward, props_54);
            },
            small: true,
            sx: some({
                alignSelf: "flex-end",
            }),
        })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty(), delay(() => {
            let elems_13, elems_12;
            return append(singleton(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                display: "flex",
                flexDirection: "column",
                gap: 15 + "px",
                minWidth: 185 + "px",
            }], (elems_13 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Orders.Orders")]]), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 10 + "px",
            }], (elems_12 = [createElement(Components_OrderStatusCard_Z2E686B84, {
                groupId: groupId,
                customerId: customerId,
                machineId: machine.Id,
            })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => {
                let elems_14;
                return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 15 + "px",
                    minWidth: 185 + "px",
                }], (elems_14 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", ctx.Locale.t("CustomerSite.Overview.DeviationWarranties")]]), createElement(Tickets_WarrantyStatusCard_Z2E686B84, {
                    groupId: groupId,
                    customerId: customerId,
                    machineId: machine.Id,
                })], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))];
    return react.createElement(react.Fragment, {}, ...xs_20);
}

